export default __webpack_public_path__ + "static/media/fa-logo.2ec82dfb.png";